import { FAIconName, InputGroupV2, UniversalSelect } from '@equip.health/ui';

interface GroupClassCommonFieldProps {
  label: string;
  options: { label: string; value: string }[];
  onChange: (value: string) => void;
  leftIcon?: FAIconName;
  selectedValue?: string;
  shouldShowAsteriskWhenRequired?: boolean;
  isDisabled?: boolean;
  modalId?: string;
  shouldHideOptionalLabel?: boolean;
}

const TOP_LEVEL_ID = 'group-class-common-field';

export const GroupClassCommonField = ({
  label,
  options,
  onChange,
  leftIcon,
  selectedValue,
  shouldShowAsteriskWhenRequired,
  isDisabled = false,
  modalId,
  shouldHideOptionalLabel = false,
}: GroupClassCommonFieldProps) => {
  const selectedOption = options?.find?.(
    (option) => option?.value === selectedValue,
  );

  return (
    <InputGroupV2
      id={`${TOP_LEVEL_ID}__duration`}
      label={label}
      isRequired={shouldShowAsteriskWhenRequired}
      shouldShowAsteriskWhenRequired={shouldShowAsteriskWhenRequired}
      shouldHideOptionalLabel={shouldHideOptionalLabel}
    >
      <UniversalSelect
        id={`${TOP_LEVEL_ID}__duration-select`}
        isSingleSelect
        onChange={(option) => {
          const selectedValue = option ? option.value : '';
          onChange(selectedValue);
        }}
        leftIcon={leftIcon}
        options={options}
        placeholder="Please choose"
        value={selectedOption ?? null}
        isDisabled={isDisabled}
        modalId={modalId}
      />
    </InputGroupV2>
  );
};
